import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

let url = wixLocation.url;

console.log("url---cons")
console.log(url)

$w.onReady(function () {
 
});

const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

async function fireEvent(buttonName) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: buttonName,
            is_valid: true,
            topic: 'wix partners site',
            url: wixLocation.url
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}

export async function partnerProgram_click(event) {
    const biEventObject = {
        evid: 703,
        button_name: 'partners hp',
        is_valid: true,
        topic: 'wix partners site',
        url: wixLocation.url
    };
    await biLogger.log(biEventObject);
}

export function startNowNav_click(event) { 
    fireLetsTalkEvent("Let’s Talk")
}

async function fireLetsTalkEvent(button) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: "partners site",
            url: wixLocation.url,
            Additional_info: "header_lets_talk"
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}